module.exports = __webpack_public_path__ + "static/img/11bg_2.33921a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/11bg_2.png
// module id = 621
// module chunks = 1